var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('generic-button',{attrs:{"variant":_vm.variant,"title":_vm.withText?'NewEmail':'',"icon":_vm.withIcon?'envelope':'',"size":_vm.size,"block":_vm.block,"is-disabled":_vm.isDisabled},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }